import { Component, Inject, Input, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { PageContainerService } from '../../services';
import { ReadinessTrafficLightRuleDto, SaveReadinessTrafficLightRuleCommandRequest, SaveReadinessTrafficLightRuleCommandResponse } from '../../data/CommandServiceDtos.generated';

@Component({
  standalone: false,
  selector: 'readiness-traffic-lights-settings',
  templateUrl: './readiness-traffic-lights-settings.component.html',
  styleUrls: ['./readiness-traffic-lights-settings.component.scss'],
})
export class ReadinessTrafficLightsSettingsComponent implements OnInit {
  @Input() SectionName: string;
  @Input() ProPakProjectId: number;
  trafficLightRules: any;
  readinessTrafficLightsData: ReadinessTrafficLightRuleDto[] = [];

  constructor(@Inject(MAT_DIALOG_DATA) public data: any, public pcs: PageContainerService, private dialog: MatDialogRef<ReadinessTrafficLightsSettingsComponent>) { }

  ngOnInit() {
    this.SectionName = this.data.SectionName;
    this.ProPakProjectId = this.data.ProPakProjectId;
    this.GetReadinessTrafficLightsData()
  }

  async GetReadinessTrafficLightsData() {
    try {
      const response = await this.pcs.apiService.GetReadinessTrafficLightRule({ SectionName: this.SectionName, ProPakProjectId: this.ProPakProjectId });

      if (response && response.ReadinessTrafficLightData.length > 0) {        
        // this.trafficLightRules = response.ReadinessTrafficLightData.sort((a, b) => b.RuleOrder - a.RuleOrder);
        this.trafficLightRules = response.ReadinessTrafficLightData;
      } else {
        console.error("Invalid API response:", response);
        this.trafficLightRules = [
           {
          ReadinessTrafficLightRuleId: 0,
          ProjectId: this.ProPakProjectId,
          SectionName: this.SectionName,
          Color: "#70ad47",
          Operator: "<=",
          ThresholdValue: 0,
          RuleOrder: 1
        },
        {
          ReadinessTrafficLightRuleId: 0,
          ProjectId: this.ProPakProjectId,
          SectionName: this.SectionName,
          Color: "#ffc000",
          Operator: "==",
          ThresholdValue: 0,
          RuleOrder: 2
        },
        {
          ReadinessTrafficLightRuleId: 0,
          ProjectId: this.ProPakProjectId,
          SectionName: this.SectionName,
          Color: "#ff0000",
          Operator: ">=",
          ThresholdValue: 0,
          RuleOrder: 3
        }
        ];
      }
    } catch (error) {
      console.error("Error fetching readiness traffic lights data:", error);
    }

  }

  closeDialog(): void {
    this.dialog.close();
  }

  async save() {
    const projectId = this.ProPakProjectId;
    const sectionName = this.SectionName;

    this.readinessTrafficLightsData = this.trafficLightRules.map((rule, index) => {
      let thresholdValue = rule.ThresholdValue;

      if (index === 2 && (thresholdValue === null || thresholdValue === undefined)) {
        thresholdValue = this.trafficLightRules[1] && this.trafficLightRules[1].ThresholdValue != null ? this.trafficLightRules[1].ThresholdValue : null;
      }

      return {
        ProjectId: projectId,
        SectionName: sectionName,
        Color: rule.Color,
        Operator: rule.Operator,
        ThresholdValue: thresholdValue,
        RuleOrder: index + 1,
        ReadinessTrafficLightRuleId: 0
      };
    });

    let readinessTableData = {
      ReadinessTrafficLightData: this.readinessTrafficLightsData,
      ProPakProjectId: this.ProPakProjectId
    };

    let response = await this.saveReadinessTrafficLightsData(readinessTableData);
    if (response) {

    }
  }

  async saveReadinessTrafficLightsData(request: SaveReadinessTrafficLightRuleCommandRequest) {
    const response: SaveReadinessTrafficLightRuleCommandResponse = await this.pcs.apiService.SaveReadinessTrafficLightRule(request, true, false);
    return this.processSaveResponse(response);
  }

  processSaveResponse(response: any) {
    if (response.ReadinessTrafficLightData.length > 0) {
      void this.pcs.alert('Your changes have been saved successfully!', 'Saved', 'success');
      return true;
    }
    else {
      return false;
    }
  }

}
